import "./App.css";

import { TextEllipsis } from "react-text-ellipsis-component";

function App() {
  return (
    <div>
      <div style={{ marginBottom: "20px", fontWeight: "bold" }}>2000 rows</div>
      <div style={{ marginBottom: "20px" }}>
        <a
          href="https://github.com/maksugr/react-text-ellipsis-component"
          target="_blank"
          rel="noreferrer"
        >
          Link to React Text Ellipsis Component
        </a>
      </div>
      <div>
        {Array(2000)
          .fill(null)
          .map((_, i) => (
            <div style={{ display: "flex", width: "100%" }} key={i}>
              <div
                style={{
                  width: "50%",
                  border: "1px solid black",
                  boxSizing: "border-box",
                }}
              >
                <TextEllipsis
                  tailLength={4}
                  title="left"
                  className={i === 7 ? "red" : ""}
                >
                  feature/create-new-text-ellipsis-component-TC2018.02
                </TextEllipsis>
              </div>
              <div
                style={{
                  width: "50%",
                  border: "1px solid black",
                  boxSizing: "border-box",
                }}
              >
                <TextEllipsis
                  tailLength={4}
                  title="right"
                  className={i === 5 ? "blue" : ""}
                >
                  Very-Long-Hardcoded-Text-Without-Controls-With-Tail-4
                </TextEllipsis>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default App;
